import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {MatPaginator, MatSort, PageEvent} from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {BaseListComponent} from '../../SharedModule/BaseListComponent/base-list.component';
import {SnackService} from '../../services/snack.service';
import {DialogService} from '../../services/dialog.service';
import {Router} from '@angular/router';
import {merge} from 'rxjs/observable/merge';
import {SortInfo} from '../../model/Helpers/SortInfo';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {Filter} from '../../model/Helpers/Filter';
import {ProductService} from '../../services/product.service';
import {ProductsDataSource} from '../../model/DataSources/ProductsDataSource';
import {Product} from '../../model/Entities/Product';
import {ProductDeleteConfirmDialogComponent} from '../ProductDeleteConfirmDialogComponent/product-delete-confirm.dialog.component';
import {Pagination} from '../../model/Helpers/Pagination';
import {ProductLabelsPrintDialogComponent} from '../ProductLabelsPrintDialogComponent/product-labels-print.dialog.component';
import {PrintService} from '../../services/print.service';
import {ProductType} from '../../model/Entities/ProductType';
import {ProductCategoryService} from '../../services/product-category.service';
import {ProductCategory} from '../../model/Entities/ProductCategory';
import {InventoryCheckDialogComponent} from '../InventoryCheckDialogComponent/inventory-check.dialog.component';
import {environment} from '../../environments/environment';

@Component({
    selector: 'products-list',
    templateUrl: './products-list.component.html',
    styleUrls: ['./products-list.component.scss']
})

export class ProductsListComponent extends BaseListComponent implements AfterViewInit {
    productTypeClass: any = ProductType;

    tableColumns: String[] = ['code', 'name', 'price', 'stockCount', 'actions'];

    defaultFilters = {
        type: 'all',
        categoryId: null
    };

    categories: ProductCategory[] = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('search') search: ElementRef;

    printPreparation = false;
    productsToPrint: number[] = [];

    constructor(private productService: ProductService,
                private productCategoryService: ProductCategoryService,
                private snackService: SnackService,
                private dialogService: DialogService,
                private printService: PrintService,
                private router: Router) {
        super();

        this.dataSource = new ProductsDataSource(this.productService);
    }

    ngAfterViewInit() {
        this.loadProductCategories();
        this.prepareDataLoading();
        this.reloadPage();

        // If the user changes the sort order, reset back to the first page.
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }

    prepareDataLoading(): void {
        merge(
            this.paginator.page,
            this.sort.sortChange,
            Observable.fromEvent(this.search.nativeElement, 'keyup').debounceTime(150).distinctUntilChanged(),
            this.dataChangedEventSubject
        ).subscribe(() => {
            if (!this.dataSource) {
                return;
            }

            const f = [];

            if (this.filters.type !== 'all' && this.filters.type) {
                f.push(new Filter('type', this.filters.type));
            }

            if (this.filters.productCategoryId !== null && this.filters.productCategoryId) {
                f.push(new Filter('product_category_id', this.filters.productCategoryId));
            }

            if (this.search.nativeElement.value.trim().length > 0) {
                f.push(new Filter('search', this.search.nativeElement.value));
            }

            this.dataSource.loadPage(
                new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                new SortInfo(this.sort.active, this.sort.direction),
                f,
              {expand: 'count'});
        });
    }

    setFirstPage() {
        this.paginator.pageIndex = 0;
    }

    showProductDetail(product: Product): void {
        this.router.navigate([`/product/${product.id}`]);
    }

    delete(product: Product): void {
        this.dialogService.showDialog(ProductDeleteConfirmDialogComponent, {
            'product': product
        }).afterClosed().subscribe((result) => {
            if (result) {
                this.productService.delete(product.id).subscribe(() => {
                    this.snackService.showSuccess(`Zboží ${product.name} bylo smazáno`);
                    this.reloadPage();
                });
            }
        });
    }

    toggleProductToPrint(productId: number) {
        const i = this.productsToPrint.indexOf(productId);
        if (i < 0) {
            this.productsToPrint.push(productId);
        } else {
            this.productsToPrint.splice(i, 1);
        }
    }

    printLabels() {
        this.dialogService.showDialog(ProductLabelsPrintDialogComponent, {}).afterClosed().subscribe((result) => {
            if (result !== false) {
                const url = this.printService.getProductLabelsPrintUrl(this.productsToPrint, result.count, result.offset);
                if (!window.open(url, '_blank')) {
                    this.snackService.showWarn('Povolte vyskakovací okna ve svém prohlížeči');
                } else {
                    this.productsToPrint = [];
                    this.printPreparation = false;
                }
            }
        });
    }

    loadProductCategories(): void {
        this.productCategoryService.getSimpleList([], {order: 'order'}).subscribe((cats: ProductCategory[]) => {
            this.categories = cats;
        });
    }

    showInventoryCheckDialog() {

        this.dialogService.showDialog(InventoryCheckDialogComponent, {}).afterClosed().subscribe((result) => {
            if (result) {
                const url = this.printService.getInventoryCheckPrintUrl(result.date);
                if (!window.open(url, '_blank')) {
                    this.snackService.showWarn('Povolte vyskakovací okna ve svém prohlížeči');
                }
            }
        });
    }

    showEshopProduct(product: Product) {

        const url =  environment.eshopAdmin + '/#/products/' + product.eshopExportId;
        window.open(url, "_blank");
    }
}




// WEBPACK FOOTER //
// /app/src/ProductsModule/ProductsListComponent/products-list.component.ts